import { extendTheme } from '@chakra-ui/react'
import { colors, config, semanticTokens } from './foundations/colors'
import { fonts, textStyles } from './foundations/typography'
import { shadows } from './foundations/shadows'
import { radii } from './foundations/radii'
import { globalStyles } from './globalStyles'
import { modalTheme, toastTheme, drawerTheme } from './components/modal'
import {
  badgeTheme,
  buttonTheme,
  inputTheme,
  numberInputTheme,
  selectTheme,
  tableTheme,
  tabsTheme,
  textareaTheme,
  dividerTheme,
} from './components/controls'
import {
  menuTheme,
  popoverTheme,
  tooltipTheme,
  alertTheme,
} from './components/overlays'
import {
  accordionTheme,
  breadcrumbTheme,
  formErrorTheme,
  formHelperTextTheme,
  formLabelTheme,
  linkTheme,
  listTheme,
  skeletonTheme,
  spinnerTheme,
  progressTheme,
  tagTheme,
} from './components/surfaces'

/** Chakra component overrides — every overlay/surface primitive routes through semantic tokens. */
export const theme = extendTheme({
  colors,
  config,
  semanticTokens,
  shadows,
  radii,
  fonts,
  textStyles,
  styles: { global: globalStyles },
  components: {
    Modal: modalTheme,
    Drawer: drawerTheme,
    Toast: toastTheme,
    Button: buttonTheme,
    Input: inputTheme,
    Select: selectTheme,
    Textarea: textareaTheme,
    NumberInput: numberInputTheme,
    Badge: badgeTheme,
    Menu: menuTheme,
    Popover: popoverTheme,
    Tooltip: tooltipTheme,
    Alert: alertTheme,
    Accordion: accordionTheme,
    FormLabel: formLabelTheme,
    FormHelperText: formHelperTextTheme,
    FormError: formErrorTheme,
    Tag: tagTheme,
    Skeleton: skeletonTheme,
    Spinner: spinnerTheme,
    Progress: progressTheme,
    Link: linkTheme,
    Breadcrumb: breadcrumbTheme,
    List: listTheme,
    Tabs: tabsTheme,
    Table: tableTheme,
    Divider: dividerTheme,
  },
})
